export default __webpack_public_path__ + "static/media/Path.c1188736.svg";